if (!customElements.get('cart-coupon-form')) {
  customElements.define(
    'cart-coupon-form',
    class CartCouponForm extends HTMLElement {
      constructor() {
        super();

        this.rootUrl = this.dataset.rootUrl || '/';

        const couponField = this.querySelector('[data-coupon-field]');
        couponField?.addEventListener('submit', (event) => {
          event.preventDefault();
          const input = couponField.querySelector('.cart-coupon__input');
          const applyButton = couponField.querySelector('.cart-coupon__apply');
          this.applyCode(input?.value, applyButton);
        });

        this.querySelectorAll('[data-offer-code]').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            this.applyCode(button.dataset.offerCode, button);
          });
        });
      }

      applyCode(code, triggerButton) {
        const trimmedCode = (code || '').trim();
        if (!trimmedCode) return;

        // The apply flow is a full page navigation (the only mechanism available on
        // Shopify Basic), which is inherently slower than an in-place update — give
        // immediate feedback so the click doesn't feel like it did nothing, and
        // block repeat clicks while the navigation is in flight.
        if (triggerButton) {
          triggerButton.disabled = true;
          triggerButton.textContent = this.dataset.applyingText || triggerButton.textContent;
        }
        this.querySelectorAll('button').forEach((button) => {
          if (button !== triggerButton) button.disabled = true;
        });

        // Always land on the cart page after applying, regardless of which page the
        // drawer was open on — using the current page's path here would send the
        // customer back to wherever they were browsing (e.g. the homepage) instead
        // of somewhere that actually shows the applied discount.
        const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
        const cartPath = `${this.rootUrl}cart`.replace(/\/{2,}/g, '/');
        const redirectTarget = previewThemeId ? `${cartPath}?preview_theme_id=${previewThemeId}` : cartPath;
        const redirect = encodeURIComponent(redirectTarget);

        let discountUrl = `${this.rootUrl}discount/${encodeURIComponent(trimmedCode)}?redirect=${redirect}`;
        if (previewThemeId) {
          discountUrl += `&preview_theme_id=${previewThemeId}`;
        }

        window.location.href = discountUrl;
      }
    }
  );
}
